// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    MedicalBiRequest,
    MedicalBiRequestSearchRequest,
    MedicalBiResultSearchRequest,
    MedicalCardFinderRequestModel,
    MedicalCardFinderTransactionSearchRequestModel,
    MedicalEligibilityRequest,
    MedicalEligibilityRequestSearchRequest,
    MedicalEligibilityResultSearchRequest,
    MedicalV1MedicalCardFinderRequestResponse,
    MedicalV1MedicalCardFinderTransactionSearchResponse,
    MedicalV1MedicalV1MedicalBiDefaultResponse,
    MedicalV1MedicalV1MedicalBiRequestSearchDefaultResponse,
    MedicalV1MedicalV1MedicalBiResultSearchDefaultResponse,
    MedicalV1MedicalV1MedicalEligibilityDefaultResponse,
    MedicalV1MedicalV1MedicalEligibilityRequestSearchDefaultResponse,
    MedicalV1MedicalV1MedicalEligibilityResultSearchDefaultResponse,
    MedicalV1PriorAuthorizationDeterminationResponse,
    MedicalV1PriorAuthorizationSubmissionStatusResponse,
    PriorAuthorizationDeterminationRequest,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeMedicalApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param medicalCardFinderRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async medicalCardFinderRequest (medicalCardFinderRequestModel: MedicalCardFinderRequestModel, xProgramId?: string): Promise<AxiosResponse<MedicalV1MedicalCardFinderRequestResponse>> {
        const _url_ = '/edge/medical/v1/MedicalCardFinder/request';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'medicalCardFinderRequestModel' is not null or undefined
        if (medicalCardFinderRequestModel === null || medicalCardFinderRequestModel === undefined) {
            throw new Error('Required parameter medicalCardFinderRequestModel was null or undefined when calling medicalCardFinderRequest.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(medicalCardFinderRequestModel, "MedicalCardFinderRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MedicalV1MedicalCardFinderRequestResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MedicalV1MedicalCardFinderRequestResponse");
        }
        return response;
    }
    /**
     * 
     * @param medicalCardFinderTransactionSearchRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async medicalCardFinderTransactionSearch (medicalCardFinderTransactionSearchRequestModel: MedicalCardFinderTransactionSearchRequestModel, xProgramId?: string): Promise<AxiosResponse<MedicalV1MedicalCardFinderTransactionSearchResponse>> {
        const _url_ = '/edge/medical/v1/MedicalCardFinder/transactionSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'medicalCardFinderTransactionSearchRequestModel' is not null or undefined
        if (medicalCardFinderTransactionSearchRequestModel === null || medicalCardFinderTransactionSearchRequestModel === undefined) {
            throw new Error('Required parameter medicalCardFinderTransactionSearchRequestModel was null or undefined when calling medicalCardFinderTransactionSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(medicalCardFinderTransactionSearchRequestModel, "MedicalCardFinderTransactionSearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MedicalV1MedicalCardFinderTransactionSearchResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MedicalV1MedicalCardFinderTransactionSearchResponse");
        }
        return response;
    }
    /**
     * 
     * @param priorAuthorizationDeterminationRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async medicalPriorAuthorizationDetermination (priorAuthorizationDeterminationRequest: PriorAuthorizationDeterminationRequest, xProgramId?: string): Promise<AxiosResponse<MedicalV1PriorAuthorizationDeterminationResponse>> {
        const _url_ = '/edge/medical/v1/PriorAuthorization/determination';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'priorAuthorizationDeterminationRequest' is not null or undefined
        if (priorAuthorizationDeterminationRequest === null || priorAuthorizationDeterminationRequest === undefined) {
            throw new Error('Required parameter priorAuthorizationDeterminationRequest was null or undefined when calling medicalPriorAuthorizationDetermination.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(priorAuthorizationDeterminationRequest, "PriorAuthorizationDeterminationRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MedicalV1PriorAuthorizationDeterminationResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MedicalV1PriorAuthorizationDeterminationResponse");
        }
        return response;
    }
    /**
     * 
     * @param transactionCorrelationId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async medicalPriorAuthorizationSubmissionStatus (transactionCorrelationId: string, xProgramId?: string): Promise<AxiosResponse<MedicalV1PriorAuthorizationSubmissionStatusResponse>> {
        const _url_ = '/edge/medical/v1/PriorAuthorization/submissionStatus/{transactionCorrelationId}'
            .replace('{' + 'transactionCorrelationId' + '}', encodeURIComponent(String(transactionCorrelationId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'transactionCorrelationId' is not null or undefined
        if (transactionCorrelationId === null || transactionCorrelationId === undefined) {
            throw new Error('Required parameter transactionCorrelationId was null or undefined when calling medicalPriorAuthorizationSubmissionStatus.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MedicalV1PriorAuthorizationSubmissionStatusResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MedicalV1PriorAuthorizationSubmissionStatusResponse");
        }
        return response;
    }
    /**
     * 
     * @param medicalBiRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async medicalV1MedicalBi (medicalBiRequest: MedicalBiRequest, xProgramId?: string): Promise<AxiosResponse<MedicalV1MedicalV1MedicalBiDefaultResponse>> {
        const _url_ = '/edge/medical/v1/MedicalBi';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'medicalBiRequest' is not null or undefined
        if (medicalBiRequest === null || medicalBiRequest === undefined) {
            throw new Error('Required parameter medicalBiRequest was null or undefined when calling medicalV1MedicalBi.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(medicalBiRequest, "MedicalBiRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MedicalV1MedicalV1MedicalBiDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MedicalV1MedicalV1MedicalBiDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param medicalBiRequestSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async medicalV1MedicalBiRequestSearch (medicalBiRequestSearchRequest: MedicalBiRequestSearchRequest, xProgramId?: string): Promise<AxiosResponse<MedicalV1MedicalV1MedicalBiRequestSearchDefaultResponse>> {
        const _url_ = '/edge/medical/v1/MedicalBiRequestSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'medicalBiRequestSearchRequest' is not null or undefined
        if (medicalBiRequestSearchRequest === null || medicalBiRequestSearchRequest === undefined) {
            throw new Error('Required parameter medicalBiRequestSearchRequest was null or undefined when calling medicalV1MedicalBiRequestSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(medicalBiRequestSearchRequest, "MedicalBiRequestSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MedicalV1MedicalV1MedicalBiRequestSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MedicalV1MedicalV1MedicalBiRequestSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param medicalBiResultSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async medicalV1MedicalBiResultSearch (medicalBiResultSearchRequest: MedicalBiResultSearchRequest, xProgramId?: string): Promise<AxiosResponse<MedicalV1MedicalV1MedicalBiResultSearchDefaultResponse>> {
        const _url_ = '/edge/medical/v1/MedicalBiResultSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'medicalBiResultSearchRequest' is not null or undefined
        if (medicalBiResultSearchRequest === null || medicalBiResultSearchRequest === undefined) {
            throw new Error('Required parameter medicalBiResultSearchRequest was null or undefined when calling medicalV1MedicalBiResultSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(medicalBiResultSearchRequest, "MedicalBiResultSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MedicalV1MedicalV1MedicalBiResultSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MedicalV1MedicalV1MedicalBiResultSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param medicalEligibilityRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async medicalV1MedicalEligibility (medicalEligibilityRequest: MedicalEligibilityRequest, xProgramId?: string): Promise<AxiosResponse<MedicalV1MedicalV1MedicalEligibilityDefaultResponse>> {
        const _url_ = '/edge/medical/v1/MedicalEligibility';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'medicalEligibilityRequest' is not null or undefined
        if (medicalEligibilityRequest === null || medicalEligibilityRequest === undefined) {
            throw new Error('Required parameter medicalEligibilityRequest was null or undefined when calling medicalV1MedicalEligibility.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(medicalEligibilityRequest, "MedicalEligibilityRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MedicalV1MedicalV1MedicalEligibilityDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MedicalV1MedicalV1MedicalEligibilityDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param medicalEligibilityRequestSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async medicalV1MedicalEligibilityRequestSearch (medicalEligibilityRequestSearchRequest: MedicalEligibilityRequestSearchRequest, xProgramId?: string): Promise<AxiosResponse<MedicalV1MedicalV1MedicalEligibilityRequestSearchDefaultResponse>> {
        const _url_ = '/edge/medical/v1/MedicalEligibilityRequestSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'medicalEligibilityRequestSearchRequest' is not null or undefined
        if (medicalEligibilityRequestSearchRequest === null || medicalEligibilityRequestSearchRequest === undefined) {
            throw new Error('Required parameter medicalEligibilityRequestSearchRequest was null or undefined when calling medicalV1MedicalEligibilityRequestSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(medicalEligibilityRequestSearchRequest, "MedicalEligibilityRequestSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MedicalV1MedicalV1MedicalEligibilityRequestSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MedicalV1MedicalV1MedicalEligibilityRequestSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param medicalEligibilityResultSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async medicalV1MedicalEligibilityResultSearch (medicalEligibilityResultSearchRequest: MedicalEligibilityResultSearchRequest, xProgramId?: string): Promise<AxiosResponse<MedicalV1MedicalV1MedicalEligibilityResultSearchDefaultResponse>> {
        const _url_ = '/edge/medical/v1/MedicalEligibilityResultSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'medicalEligibilityResultSearchRequest' is not null or undefined
        if (medicalEligibilityResultSearchRequest === null || medicalEligibilityResultSearchRequest === undefined) {
            throw new Error('Required parameter medicalEligibilityResultSearchRequest was null or undefined when calling medicalV1MedicalEligibilityResultSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(medicalEligibilityResultSearchRequest, "MedicalEligibilityResultSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MedicalV1MedicalV1MedicalEligibilityResultSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MedicalV1MedicalV1MedicalEligibilityResultSearchDefaultResponse");
        }
        return response;
    }
}
